/**
 * @generated SignedSource<<9972e650d73037b0300d7da7ba3638aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentType = "BANK_TRANSFER" | "CASH" | "PAYSERA";
import { FragmentRefs } from "relay-runtime";
export type PaymentType_payment$data = {
  readonly type: PaymentType;
  readonly " $fragmentType": "PaymentType_payment";
};
export type PaymentType_payment$key = {
  readonly " $data"?: PaymentType_payment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentType_payment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentType_payment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Payment",
  "abstractKey": null
};

(node as any).hash = "9b606f8993f0046897bcc1430236d9de";

export default node;
